import { render, staticRenderFns } from "./xInfo-Card.vue?vue&type=template&id=630b2736&scoped=true&"
import script from "./xInfo-Card.vue?vue&type=script&lang=js&"
export * from "./xInfo-Card.vue?vue&type=script&lang=js&"
import style0 from "./xInfo-Card.vue?vue&type=style&index=0&id=630b2736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b2736",
  null
  
)

export default component.exports